export default {
      id: "upload-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.dd84271a.svg#upload",
      toString: function () {
        return this.url;
      }
    }